import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=c84f3f1a&scoped=true&"
import script from "./FilterSelector.vue?vue&type=script&lang=js&"
export * from "./FilterSelector.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelector.vue?vue&type=style&index=0&id=c84f3f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84f3f1a",
  null
  
)

export default component.exports